import { EnvironmentInterface } from "./environment.types";

export const environment: EnvironmentInterface = {
    production: false,
    environment: "uat",
    appUrl: "http://localhost:4200",
    tilesUrl: "https://tiles-service.abacus-consulting.net",
    mapboxKey: "pk.eyJ1IjoidmFkaW12dCIsImEiOiJjbHZ4OHZzZGMweWp3MnFwamc2a2htazR6In0.qDF57PiSxIcOpLVaXN7TXA",
    maptilerKey: "XpKLC1pHKxoEA6bfV7eG",
    meiliPass: "l8dxB1Kk2zM3vHnfl5uN_oTWcK8zRYR96ZV8Eu6AyA6xT3P38mZh0gA0H5eVP1ZdZ4wzVli0A8g",
    brandingDomain: "geoactivate.com",
    brandingDomains: ["geoactivate.com", "geoactivate.ai", "appcelerate.app", "geoactivate.dev135.abacus-consulting.net"],
    features: {
        // Encendido: necesita geoactivate-api#17 (selector) y #55 (motivo en derivable-inputs) desplegadas antes que este front.
        dtsGeoAudienceSelector: true,
        // País de testing E2 (Spain over H3). Solo pre/dev; en prod se queda en false.
        e2TestCountry: true,
        // Encender cuando /drive-to-store esté verificada en preprod y comunicada en la demo.
        dtsTabRetired: false,
    },
};
